import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import PricingForm from "../forms/pricingForm";
import BusinessHoursBlock from "../common/BusinessHoursBlock";

function Hero() {
  return (
    <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36">
      <img
        className="absolute w-full h-full object-cover z-10 top-0 left-0"
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/contactimg.jpeg"
        alt="Kontakt z Drzewus - usługi ogrodnicze"
      />
      <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
      <div className="flex flex-col items-start justify-center gap-2 z-30 mb-6 lg:mb-0">
        <h2 className="text-white font-semibold text-sm">Drzewus - Usługi ogrodnicze i prace ziemne </h2>
        <h1 className="text-3xl lg:text-6xl text-white">Kontakt</h1>
        <h2 className="text-xl lg:text-3xl text-white mb-6 text-left">
          Darmowa wycena oczyszczania i mulczowania działek – Gdańsk i Pomorskie
        </h2>
        <div className="flex flex-col items-start justify-start gap-2 text-lg lg:text-2xl">
          <a
            href="mailto:kontakt@drzewus.pl"
            className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-end"
          >
            <IoMail />
            <span>kontakt@drzewus.pl</span>
          </a>
          <p className="text-white font-semibold mt-2">
            Porady, wyceny, doradztwo
          </p>
          <a
            href="tel:+48604351852"
            className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-start"
          >
            <FaPhoneAlt />
            <span>+48 604 351 852</span>
          </a>
          <p className="text-white font-semibold mt-2">Biuro</p>
          <a
            href="tel:+48503752050"
            className="hover:opacity-50 transition duration-300 ease-linear flex flex-row items-center text-white gap-2 justify-start"
          >
            <FaPhoneAlt />
            <span>+48 503 752 050</span>
          </a>
          <BusinessHoursBlock
            className="mt-4"
            titleClassName="text-white font-semibold text-sm lg:text-base"
            lineClassName="text-white text-sm lg:text-base opacity-90"
          />
        </div>
      </div>
      <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
        {" "}
        <PricingForm />
      </div>
    </section>
  );
}

export default Hero;
